// Generated by purs version 0.15.16
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Shape from "../GraphQL.Shape/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
var rltvCons = /* #__PURE__ */ GraphQL_Query.rltvCons(GraphQL_Query.rltvNil);
var parent_typeIsSymbol = {
    reflectSymbol: function () {
        return "parent_type";
    }
};
var encRNTY = /* #__PURE__ */ GraphQL_Type.encRNTY(Data_Argonaut_Encode_Class.encodeJsonJString);
var parent_idIsSymbol = {
    reflectSymbol: function () {
        return "parent_id";
    }
};
var dataIsSymbol = {
    reflectSymbol: function () {
        return "data";
    }
};
var fileIsSymbol = {
    reflectSymbol: function () {
        return "file";
    }
};
var descriptionIsSymbol = {
    reflectSymbol: function () {
        return "description";
    }
};
var rltvfConsOther = /* #__PURE__ */ GraphQL_Query.rltvfConsOther(GraphQL_Query.rltvfNil);
var deleteIsSymbol = {
    reflectSymbol: function () {
        return "delete";
    }
};
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var userIsSymbol = {
    reflectSymbol: function () {
        return "user";
    }
};
var urlIsSymbol = {
    reflectSymbol: function () {
        return "url";
    }
};
var pathIsSymbol = {
    reflectSymbol: function () {
        return "path";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var created_atIsSymbol = {
    reflectSymbol: function () {
        return "created_at";
    }
};
var canIsSymbol = {
    reflectSymbol: function () {
        return "can";
    }
};
var rlhsCons = /* #__PURE__ */ GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsNil);
var jsonQR = /* #__PURE__ */ GraphQL_Query.jsonQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(deleteIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Internal_Luxon.decodeLDT))(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(nameIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(userIsSymbol)()())(urlIsSymbol)()())(pathIsSymbol)()())(idIsSymbol)()())(descriptionIsSymbol)()())(created_atIsSymbol)()())(canIsSymbol)()())())(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(userIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(nameIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(urlIsSymbol)(GraphQL_Shape.scalarShape)()())(pathIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(descriptionIsSymbol)(GraphQL_Shape.scalarShape)()())(created_atIsSymbol)(GraphQL_Shape.scalarShape)()())(canIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(deleteIsSymbol)(GraphQL_Shape.scalarShape)()())())()())());
var buildMutation = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ rltvCons(parent_typeIsSymbol)(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "AttachmentParentType";
    }
}))(encRNTY)()())(parent_idIsSymbol)(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "ID";
    }
}))(encRNTY)()())(dataIsSymbol)(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "AttachmentInput";
    }
}))(/* #__PURE__ */ GraphQL_Type.encRNTY(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(GraphQL_Query.fuEnc)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(fileIsSymbol)())(descriptionIsSymbol)())()))()())(/* #__PURE__ */ GraphQL_Query.rltvfNamedTypeRec(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ rltvfConsOther(parent_typeIsSymbol)())(parent_idIsSymbol)())(dataIsSymbol)()()(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ GraphQL_Query.rltvfConsFU(GraphQL_Query.rltvfNil)(fileIsSymbol)())(descriptionIsSymbol)()))())(jsonQR);
var buildMutation1 = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons(idIsSymbol)(GraphQL_Type.hqtID)(GraphQL_Type.encQID)()())(/* #__PURE__ */ rltvfConsOther(idIsSymbol)())())(jsonQR);
var FormAttachment = /* #__PURE__ */ (function () {
    function FormAttachment(value0) {
        this.value0 = value0;
    };
    FormAttachment.create = function (value0) {
        return new FormAttachment(value0);
    };
    return FormAttachment;
})();
var postAttachment = function (parent) {
    return function (input) {
        var parent$prime = {
            id: parent.value0,
            type: "FORM"
        };
        return buildMutation("createAttachment")({
            parent_id: parent$prime.id,
            parent_type: GraphQL_Type.namedType(parent$prime.type),
            data: GraphQL_Type.namedType({
                description: input.description,
                file: GraphQL_Query.fileUpload(input.file)
            })
        });
    };
};
var deleteAttachment = function (id) {
    return buildMutation1("deleteAttachment")({
        id: new GraphQL_Type.QID(id)
    });
};
export {
    FormAttachment,
    postAttachment,
    deleteAttachment
};
//# sourceMappingURL=index.js.map
